import { Mail, Phone, Facebook, Instagram } from "lucide-react";
import "./Footer.css";

const Categories = [
  {
    title: "Chocolate Bars",
    url: "https://www.fabelle.in/bars-and-tablets?page=1",
  },
  {
    title: "Chocolate Boxes",
    url: "https://www.fabelle.in/gift-baskets?page=1",
  },
  {
    title: "Truffles & Pralines",
    url: "https://www.fabelle.in/truffles-pralines?page=1",
  },
  {
    title: "Cakes & Desserts",
    url: "https://www.fabelle.in/dessert-collection?page=1",
  },
  {
    title: "Gift Hampers",
    url: "https://www.fabelle.in/fabelle-gifting?page=1",
  },
  {
    title: "Master Class",
    url: "https://www.fabelle.in/masterclass",
  },
];

const quickLinks = [
  { title: "About Us", url: "https://www.fabelle.in/about" },
  {
    title: "Terms of Use",
    url: "https://www.fabelle.in/terms-of-use",
  },
  { title: "Contact Us", url: "https://www.fabelle.in/contact" },
  {
    title: "Privacy Policy",
    url: "https://www.fabelle.in/privacy-policy",
  },
  {
    title: "Returns, Refunds & Cancellation",
    url: "https://www.fabelle.in/refund-policy",
  },
];

export default function FooterAdmin() {
  return (
    <footer className="footer">
      <div className="footer-overlay"></div>

      <div className="footer-container">
        <div className="footer-grid">
          {/* Popular Categories */}
          <div className="footer-section">
            <h3 className="footer-title">Popular Categories</h3>
            <ul className="footer-list">
              {Categories.map((item, i) => (
                <li key={i}>
                  <a href={item.url} className="footer-link">
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-list">
              {quickLinks.map((item, i) => (
                <li key={i}>
                  <a href={item.url} className="footer-link">
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Us */}
          <div className="footer-section">
            <h3 className="footer-title">Contact Us</h3>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <Mail className="footer-icon" />
                <a href="mailto:itccares@itc.in" style={{ color: "white" }}>
                  itccares@itc.in
                </a>
              </div>
              <div className="footer-contact-item">
                <Phone className="footer-icon" />
                <a href="tel:1800-425-444-444" style={{ color: "white" }}>
                  1800-425-444-444
                </a>
              </div>
            </div>
          </div>

          {/* Social Media */}
          <div className="footer-section">
            <h3 className="footer-title">Follow Us</h3>
            <div className="footer-social">
              <a
                href="https://www.facebook.com/FabelleChocolates"
                target="_blank"
                className="social-link"
              >
                <Facebook className="footer-icon" />
              </a>
              <a
                href="https://www.instagram.com/fabellechocolates/"
                target="_blank"
                className="social-link"
              >
                <Instagram className="footer-icon" />
              </a>
            </div>
          </div>
        </div>

        <hr className="footer-divider" />

        <div className="footer-bottom">
          <p>
            © {new Date().getFullYear()}{" "}
            <span className="footer-brand">The Techtonic</span>. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
